import { render, staticRenderFns } from "./ToggleItem.vue?vue&type=template&id=0d3135b8&scoped=true"
import script from "./ToggleItem.vue?vue&type=script&lang=js"
export * from "./ToggleItem.vue?vue&type=script&lang=js"
import style0 from "./ToggleItem.vue?vue&type=style&index=0&id=0d3135b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3135b8",
  null
  
)

export default component.exports